import React from 'react';
import { AccountBalance } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  TypeGroup: string;
}

const ListCompteFRGroupe: React.FC<TypeReportProps> = ({ Entete, TypeGroup }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Module Comptes · Par groupe"
      icon={<AccountBalance />}
      endpoint="module-comptesbygroupe"
      extraParams={{ Type: TypeGroup }}
      showClientRange={false}
      showDateRange={true}
      showAgence={true}
      extraFields={[
        {
          key: 'ListGroup',
          label: 'Sélection de groupe',
          type: 'multiselect',
          fetchUrl: 'client-typegroupeclient',
          fetchParams: { TypeGroup },
          valueField: 'Code',
          labelField: 'Libelle',
          joinParam: 'ListGroup',
        },
      ]}
      fileNamePrefix="rapport_comptes_groupe"
    />
  );
};

export default ListCompteFRGroupe;
